"use client";

import { c as _c } from "react/compiler-runtime";
import { MessageCircle } from "lucide-react";
import type { CampaignPageSection } from "@growwithai/shared";
import { sectionBgStyle, sectionHeadingStyle } from "../section-style";
type CtaWhatsappProps = Extract<CampaignPageSection, {
  type: "cta_whatsapp";
}>;

/** Banner ajakan chat WhatsApp — wa.me/<nomor>?text=<pesan>. */
export default function CtaWhatsappSection(t0) {
  const $ = _c(20);
  const {
    section
  } = t0;
  let t1;
  if ($[0] !== section.wa_number) {
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = /\D/g;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    t1 = section.wa_number.replace(t2, "");
    $[0] = section.wa_number;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const number = t1;
  const href = `https://wa.me/${number}${section.message ? `?text=${encodeURIComponent(section.message)}` : ""}`;
  let t2;
  if ($[3] !== section.custom_style) {
    t2 = sectionBgStyle(section.custom_style);
    $[3] = section.custom_style;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      background: "linear-gradient(135deg, var(--brand-primary) 0%, color-mix(in srgb, var(--brand-primary) 70%, black) 100%)"
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== section.custom_style) {
    t4 = sectionHeadingStyle(section.custom_style);
    $[6] = section.custom_style;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== section.heading || $[9] !== t4) {
    t5 = <h2 className="max-w-2xl text-2xl font-bold tracking-tight text-white md:text-3xl" style={t4}>{section.heading}</h2>;
    $[8] = section.heading;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <MessageCircle className="h-5 w-5" />;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== href) {
    t7 = <a href={href} target="_blank" rel="noopener noreferrer" className="inline-flex h-12 items-center justify-center gap-2 rounded-xl bg-white px-6 text-[15px] font-semibold text-[var(--brand-primary)] shadow-md transition-transform hover:scale-[1.02] active:scale-[0.98]">{t6}Chat via WhatsApp</a>;
    $[12] = href;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t5 || $[15] !== t7) {
    t8 = <div className="mx-auto max-w-6xl px-5"><div className="flex flex-col items-center gap-6 rounded-3xl px-6 py-12 text-center md:px-12" style={t3}>{t5}{t7}</div></div>;
    $[14] = t5;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t2 || $[18] !== t8) {
    t9 = <section className="bg-white py-14 md:py-20" style={t2}>{t8}</section>;
    $[17] = t2;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
}